export const RECORDED_CONTENT_API = {
  fetch_questionnaire_status: "host/recorded/customer/questionairre/status",
  fetch_questionnaire_details: "host/content/questionairre/get",
  fetch_form_responses: "host/recorded/form/attempt/responses",
  add_exam_attempt: "host/content/attempt/create",
  submit_form_or_exam: "host/content/attempt/submit",
  update_recorded_content_mark: "users/recordedcontent/mark",
  mark_recorded_content_lesson_complete: "users/recordedsubcategory/mark",
};
